// Reordena somente as posições exibidas, preservando produtos ocultos pela busca.
export function reordenarItensVisiveis<T>(itens: T[], indices: number[], from: number, to: number): T[] {
  if (from === to || from < 0 || to < 0 || from >= indices.length || to >= indices.length) return itens;
  const visiveis = indices.map((index) => itens[index]);
  const [movido] = visiveis.splice(from, 1);
  visiveis.splice(to, 0, movido);
  const resultado = [...itens];
  indices.forEach((index, posicao) => { resultado[index] = visiveis[posicao]; });
  return resultado;
}
